module.exports = __webpack_public_path__ + "img/aeroland-ebook-box-image-03.5bda841a.png";